import { render, staticRenderFns } from "./BookSalesman.vue?vue&type=template&id=04cdbae2&scoped=true&"
import script from "./BookSalesman.vue?vue&type=script&lang=js&"
export * from "./BookSalesman.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BookSalesman.vue?vue&type=style&index=0&id=04cdbae2&prod&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "04cdbae2",
  null
  ,true
)

export default component.exports